export default "__VITE_ASSET__DsXS0MAD__"